import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GalleryModule } from "@ks89/angular-modal-gallery";
import { SharedModule } from "../shared/shared.module";
import { PagesRoutingModule } from "./pages-routing.module";

// Pages Components
import { WishlistComponent } from "./account/wishlist/wishlist.component";
import { MyOrdersComponent } from "./account/my-orders/my-orders.component";
import { NotificationsComponent } from "./account/notifications/notifications.component";
import { NotificationComponent } from "./account/notification/notification.component";
import { CartComponent } from "./account/cart/cart.component";
import { DashboardComponent } from "./account/dashboard/dashboard.component";
import { OrderComponent } from "./account/order/order.component";
import { LoginComponent } from "./account/login/login.component";
import { RegisterComponent } from "./account/register/register.component";
import { ForgetPasswordComponent } from "./account/forget-password/forget-password.component";
import { ProfileComponent } from "./account/profile/profile.component";
import { ContactComponent } from "./account/contact/contact.component";
import { CheckoutComponent } from "./account/checkout/checkout.component";
import { AboutUsComponent } from "./about-us/about-us.component";
import { PageComponent } from "./page/page.component";
import { SearchComponent } from "./search/search.component";
import { TypographyComponent } from "./typography/typography.component";
import { ReviewComponent } from "./review/review.component";
import { OrderSuccessComponent } from "./order-success/order-success.component";
import { CompareOneComponent } from "./compare/compare-one/compare-one.component";
import { CompareTwoComponent } from "./compare/compare-two/compare-two.component";
import { CollectionComponent } from "./collection/collection.component";
import { LookbookComponent } from "./lookbook/lookbook.component";
import { ErrorComponent } from "./error/error.component";
import { ComingSoonComponent } from "./coming-soon/coming-soon.component";
import { FaqComponent } from "./faq/faq.component";
// Blog Components
import { BlogLeftSidebarComponent } from "./blog/blog-left-sidebar/blog-left-sidebar.component";
import { BlogRightSidebarComponent } from "./blog/blog-right-sidebar/blog-right-sidebar.component";
import { BlogNoSidebarComponent } from "./blog/blog-no-sidebar/blog-no-sidebar.component";
import { BlogDetailsComponent } from "./blog/blog-details/blog-details.component";
// Portfolio Components
import { GridTwoComponent } from "./portfolio/grid-two/grid-two.component";
import { GridThreeComponent } from "./portfolio/grid-three/grid-three.component";
import { GridFourComponent } from "./portfolio/grid-four/grid-four.component";
import { MasonryGridTwoComponent } from "./portfolio/masonry-grid-two/masonry-grid-two.component";
import { MasonryGridThreeComponent } from "./portfolio/masonry-grid-three/masonry-grid-three.component";
import { MasonryGridFourComponent } from "./portfolio/masonry-grid-four/masonry-grid-four.component";
import { MasonryFullWidthComponent } from "./portfolio/masonry-full-width/masonry-full-width.component";
import { MyCouponesComponent } from "./account/my-coupones/my-coupones.component";
import { BrowseLogComponent } from "./account/browse-log/browse-log.component";

import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { BrowseLogItemModule } from "./account/browse-log/browse-log-item/browse-log-item.module";
import { MatRadioModule } from "@angular/material/radio";
import { CategorySupportComponent } from "./main-sections/category-support/category-support.component";
import { MatIconModule } from "@angular/material/icon";
import { ArticlesComponent } from "./main-sections/articles/articles.component";
import { StripHtmlPipe } from "../shared/pipes/strip-html.pipe";
import { SanitizeHtmlPagesPipe } from "../shared/pipes/sanitize-html-pages.pipe";
import { SearchDropComponent } from "./main-sections/search-drop/search-drop.component";
import { OrderStateComponent } from "./account/order-state/order-state.component";
import { DateTimePipe } from "../shared/pipes/date-time.pipe";
import { NgxJsonLdModule } from "ngx-json-ld";
import { TicketCouponComponent } from "./account/my-coupones/ticket-coupon/ticket-coupon.component";

@NgModule({
  declarations: [
    WishlistComponent,
    MyOrdersComponent,
    NotificationsComponent,
    NotificationComponent,
    CartComponent,
    DashboardComponent,
    OrderComponent,
    LoginComponent,
    RegisterComponent,
    ForgetPasswordComponent,
    ProfileComponent,
    ContactComponent,
    CheckoutComponent,
    AboutUsComponent,
    PageComponent,
    SearchComponent,
    TypographyComponent,
    ReviewComponent,
    OrderSuccessComponent,
    CompareOneComponent,
    CompareTwoComponent,
    CollectionComponent,
    LookbookComponent,
    ErrorComponent,
    ComingSoonComponent,
    FaqComponent,
    BlogLeftSidebarComponent,
    BlogRightSidebarComponent,
    BlogNoSidebarComponent,
    BlogDetailsComponent,
    GridTwoComponent,
    GridThreeComponent,
    GridFourComponent,
    MasonryGridTwoComponent,
    MasonryGridThreeComponent,
    MasonryGridFourComponent,
    MasonryFullWidthComponent,
    MyCouponesComponent,
    BrowseLogComponent,
    CategorySupportComponent,
    ArticlesComponent,
    StripHtmlPipe,
    SanitizeHtmlPagesPipe,
    SearchDropComponent,
    OrderStateComponent,
    DateTimePipe,
    TicketCouponComponent
  ],
  imports: [
    CommonModule,
    GalleryModule.forRoot(),
    SharedModule,
    PagesRoutingModule,
    InfiniteScrollModule,
    BrowseLogItemModule,
    MatRadioModule,
    MatIconModule,
    NgxJsonLdModule
  ],
})
export class PagesModule { }
